<template>
    <header id="header_top" v-show="appversion == 'new'">
        <section class="head_back" @click="$router.go(-1)" >
            <img src="~assets/images/back-btn.png" alt="">
             <span>{{headTitle}}</span>
        </section>
         <slot name="ask-title"></slot>
         <slot name="askTitle"></slot>
    </header>
</template>
<script>
import { getStore } from "assets/commonjs/storage";
import user from 'assets/commonjs/userInfo'
export default {
  data () {
    return {
     appversion:'new'
    }
  },
  mounted(){
      //说明是旧版本或者是移动端
      if(getStore('liveappver') != "" && getStore('liveappver') != undefined && getStore('liveappver') != null){
          //肯定是新版
          this.appversion = "new" 
      }else if(getStore('noneheader') == null  
      || getStore('noneheader') == ""  
      || getStore('noneheader') == undefined){
            //移动端
         this.appversion = 'new'
      }else{
         this.appversion = "old" 
       }
     
  },
  props:["headTitle"],
 
}
</script>
<style lang="scss" scoped>
@import "~assets/styles/mixin";
    #header_top{
        @include wh(100%,.9rem);
        position: relative;
        background: #fff;
        border-bottom: .025rem solid #ddd;
    }
    .head_back{
        @include wh(auto,.9rem);
        padding-top:.1rem;
        line-height: .9rem;
        font-size: 0;
        text-align: left;
        margin-left: .3rem;
        float: left;
        img{
             @include wh(.44rem,.44rem);
             position: relative;
             top: .1rem;
        }
         span{
            @include center;
            font-size:.32rem;
            font-weight:bold;
        }
    }
    
</style>
